import moment from "moment"
import BaseDate from "./base_date"

const SPECIALS = new Set(["today", "yesterday", "week", "month"]);

export default class Special extends BaseDate {
  constructor(str, timezone) {
    super();

    this.str = str;
    this.timezone = timezone;
    this.date = this.getDate();
  }

  dup() {
    const special = new Special(this.str, this.timezone)
    special.date = this.date.clone()
    return special
  }

  static isSpecial(str) {
    return SPECIALS.has(str);
  }

  static fromInput(str) {
    return new Special(str)
  }

  static fromParam(str) {
    return new Special(str)
  }

  valid() {
    return SPECIALS.has(this.str);
  }

  get output() {
    return this.str;
  }

  get param() {
    return this.str;
  }

  getDate() {
    switch(this.str) {
      case "today":
        return moment().startOf("d");
      case "yesterday":
        return moment().subtract(1, "d").startOf("d");
      case "week":
        return moment().startOf("week");
      case "month":
        return moment().startOf("month");
    }
  }
}
